import { tw } from '@/lib/utils'

export const SOUND_BARS = [55, 80, 35, 90, 25, 65, 45, 78, 30, 70, 40, 85, 22, 60]

interface SoundBarsProps {
  count?: number
  active?: boolean
  className?: string
  barClassName?: string
  barWidth?: string
  gapClass?: string
  baseColor?: string
  activeColor?: string
  durationOffset?: number
  delayStep?: number
}

export const SoundBars = ({
  count = SOUND_BARS.length,
  active = true,
  className,
  barClassName,
  barWidth = '2px',
  gapClass = 'gap-[3px]',
  baseColor = 'bg-navy/60',
  activeColor,
  durationOffset = 4,
  delayStep = 0.12,
}: SoundBarsProps) => {
  const color = active ? (activeColor ?? baseColor) : 'bg-navy/20'
  return (
    <div aria-hidden className={tw('flex items-end', gapClass, className)}>
      {SOUND_BARS.slice(0, count).map((h, i) => (
        <span
          key={i}
          className={tw('block rounded-full transition-colors duration-300', color, barClassName)}
          style={{
            width: barWidth,
            height: `${active ? h : Math.max(15, h * 0.35)}%`,
            animation: active
              ? `soundBar 1.${(i % 5) + durationOffset}s ease-in-out ${i * delayStep}s infinite`
              : 'none',
          }}
        />
      ))}
    </div>
  )
}
